import moment from 'moment'


export default function (d1, d2) {
  const date1 = moment(d1)
  const date2 = moment(d2)

  return date2.diff(date1, 'days')
}


// WEBPACK FOOTER //
// ./src/filters/timeBetween2Dates.js